'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.Toggle = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _templateObject = _taggedTemplateLiteral(['\n\t\t\t& > div:nth-child(1) {\n\t\t\t\tbackground-color: ', ';\n\t\t\t}\n\n\t\t\t& > div:nth-child(2) {\n\t\t\t\tbackground-color: ', ';\n\t\t\t\tleft: 100%;\n\t\t\t\tmargin-left: -20px;\n\t\t\t}\n\t\t'], ['\n\t\t\t& > div:nth-child(1) {\n\t\t\t\tbackground-color: ', ';\n\t\t\t}\n\n\t\t\t& > div:nth-child(2) {\n\t\t\t\tbackground-color: ', ';\n\t\t\t\tleft: 100%;\n\t\t\t\tmargin-left: -20px;\n\t\t\t}\n\t\t']),
    _templateObject2 = _taggedTemplateLiteral(['\n\t\t\t\twidth: 36px;\n\n\t\t\t\t& > div:nth-child(1) {\n\t\t\t\t\theight: 18px;\n\t\t\t\t}\n\n\t\t\t\t& > div:nth-child(2) {\n\t\t\t\t\twidth: 20px;\n\t\t\t\t\theight: 20px;\n\t\t\t\t}\n\t\t\t'], ['\n\t\t\t\twidth: 36px;\n\n\t\t\t\t& > div:nth-child(1) {\n\t\t\t\t\theight: 18px;\n\t\t\t\t}\n\n\t\t\t\t& > div:nth-child(2) {\n\t\t\t\t\twidth: 20px;\n\t\t\t\t\theight: 20px;\n\t\t\t\t}\n\t\t\t']),
    _templateObject3 = _taggedTemplateLiteral(['\n\t\t\t\twidth: 42px;\n\n\t\t\t\t& > div:nth-child(1) {\n\t\t\t\t\theight: 22px;\n\t\t\t\t}\n\n\t\t\t\t& > div:nth-child(2) {\n\t\t\t\t\twidth: 24px;\n\t\t\t\t\theight: 24px;\n\t\t\t\t\tleft: -5px;\n\t\t\t\t}\n\t\t\t\t\n\t\t\t'], ['\n\t\t\t\twidth: 42px;\n\n\t\t\t\t& > div:nth-child(1) {\n\t\t\t\t\theight: 22px;\n\t\t\t\t}\n\n\t\t\t\t& > div:nth-child(2) {\n\t\t\t\t\twidth: 24px;\n\t\t\t\t\theight: 24px;\n\t\t\t\t\tleft: -5px;\n\t\t\t\t}\n\t\t\t\t\n\t\t\t']),
    _templateObject4 = _taggedTemplateLiteral(['\n\t\t\t\twidth: 50px;\n\n\t\t\t\t& > div:nth-child(1) {\n\t\t\t\t\theight: 26px;\n\t\t\t\t}\n\n\t\t\t\t& > div:nth-child(2) {\n\t\t\t\t\twidth: 28px;\n\t\t\t\t\theight: 28px;\n\t\t\t\t\tleft: -8px;\n\t\t\t\t}\t\n\t\t\t'], ['\n\t\t\t\twidth: 50px;\n\n\t\t\t\t& > div:nth-child(1) {\n\t\t\t\t\theight: 26px;\n\t\t\t\t}\n\n\t\t\t\t& > div:nth-child(2) {\n\t\t\t\t\twidth: 28px;\n\t\t\t\t\theight: 28px;\n\t\t\t\t\tleft: -8px;\n\t\t\t\t}\t\n\t\t\t']),
    _templateObject5 = _taggedTemplateLiteral(['\n\ttransition: all 650ms cubic-bezier(0.23, 1, 0.32, 1) 0ms;\n\tfloat: left;\n\tposition: relative;\n\tdisplay: block;\n\tflex-shrink: 0;\n\twidth: 36px;\n\tmargin-right: 0px;\n\tmargin-left: 8px;\n\tpadding: 4px 2px 6px 2px;\n\tcursor: pointer;\n\n\t& > div:nth-child(1) {\n\t\ttransition: all 650ms cubic-bezier(0.23, 1, 0.32, 1) 0ms;\n\t\twidth: 100%;\n\t\theight: 18px;\n\t\tborder-radius: 30px;\n\t\tbackground-color: rgb(205, 205, 205);\n\t}\n\n\t& > div:nth-child(2) {\n\t\tcolor: rgba(0, 0, 0, 0.87);\n\t\tbackground-color: rgb(245, 245, 245);\n\t\ttransition: all 650ms cubic-bezier(0.23, 1, 0.32, 1) 0ms;\n\t\tbox-sizing: border-box;\n\t\t-webkit-tap-highlight-color: rgba(0, 0, 0, 0);\n\t\tbox-shadow: rgba(0, 0, 0, 0.12) 0px 1px 6px, rgba(0, 0, 0, 0.12) 0px 1px 4px;\n\t\tborder-radius: 50%;\n\t\tposition: absolute;\n\t\ttop: 3px;\n\t\tleft: 0px;\n\t\twidth: 20px;\n\t\theight: 20px;\n\t\tline-height: 24px;\n\t}\n\n\t', '\n\t', '\n'], ['\n\ttransition: all 650ms cubic-bezier(0.23, 1, 0.32, 1) 0ms;\n\tfloat: left;\n\tposition: relative;\n\tdisplay: block;\n\tflex-shrink: 0;\n\twidth: 36px;\n\tmargin-right: 0px;\n\tmargin-left: 8px;\n\tpadding: 4px 2px 6px 2px;\n\tcursor: pointer;\n\n\t& > div:nth-child(1) {\n\t\ttransition: all 650ms cubic-bezier(0.23, 1, 0.32, 1) 0ms;\n\t\twidth: 100%;\n\t\theight: 18px;\n\t\tborder-radius: 30px;\n\t\tbackground-color: rgb(205, 205, 205);\n\t}\n\n\t& > div:nth-child(2) {\n\t\tcolor: rgba(0, 0, 0, 0.87);\n\t\tbackground-color: rgb(245, 245, 245);\n\t\ttransition: all 650ms cubic-bezier(0.23, 1, 0.32, 1) 0ms;\n\t\tbox-sizing: border-box;\n\t\t-webkit-tap-highlight-color: rgba(0, 0, 0, 0);\n\t\tbox-shadow: rgba(0, 0, 0, 0.12) 0px 1px 6px, rgba(0, 0, 0, 0.12) 0px 1px 4px;\n\t\tborder-radius: 50%;\n\t\tposition: absolute;\n\t\ttop: 3px;\n\t\tleft: 0px;\n\t\twidth: 20px;\n\t\theight: 20px;\n\t\tline-height: 24px;\n\t}\n\n\t', '\n\t', '\n']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _utils = require('../utils');

var _utils2 = _interopRequireDefault(_utils);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var getColor = _utils2.default.getColor,
    getLightenedColor = _utils2.default.getLightenedColor;


var toggledMixin = function toggledMixin(props) {
	if (props.toggled) {
		return (0, _styledComponents.css)(_templateObject, function (props) {
			return getLightenedColor(props, '#fff', 0.25);
		}, function (props) {
			return getColor(props);
		});
	}
};

var sizeMixin = function sizeMixin(props) {
	switch (true) {
		case props.sm:
			return (0, _styledComponents.css)(_templateObject2);
		case props.md:
			return (0, _styledComponents.css)(_templateObject3);
		case props.lg:
			return (0, _styledComponents.css)(_templateObject4);
	}
};

var StyledToggle = _styledComponents2.default.div(_templateObject5, function (props) {
	return sizeMixin(props);
}, function (props) {
	return toggledMixin(props);
});

var Toggle = function Toggle(props) {
	return _react2.default.createElement(
		StyledToggle,
		_extends({ onClick: props.onToggle }, props),
		_react2.default.createElement('div', null),
		_react2.default.createElement('div', null)
	);
};

Toggle.propTypes = {
	onToggle: _propTypes2.default.func.isRequired
};

exports.Toggle = Toggle;